<template>
    <div class="card card-height">
        <div class="table-responsive">
            <table class="table custom-table-padding">
                <thead>
                    <tr>
                        <th>voucher no</th>
                        <th>voucher date</th>
                        <th>purchase bill no</th>
                        <th>bill date</th>
                        <th>accounts head</th>
                        <th>TDS section ref</th>
                        <th>VDS section ref</th>
                        <th>Bill Amount</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in tableItems" :key="item.id">
                        <td>{{ item.voucher_no }}</td>
                        <td>{{ item.voucher_date }}</td>
                        <td>{{ item.bill_number }}</td>
                        <td>{{ item.bill_date }}</td>
                        <td>{{ item.account_head_name }}</td>
                        <td>{{ item.tds_section_ref }}</td>
                        <td>{{ item.vds_section_ref }}</td>
                        <td class="text-right">{{ commaFormat(item.bill_amount) }}</td>
                        <td>
                            <button @click="onDeleteItem(index)" class="btn btn-sm btn-dlt">
                                <i class="fas fa-trash"></i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        <p v-if="!tableItems.length" class="text-center mt-5">No data</p>
    </div>
</div>
</template>

<script setup>
import figureFormatter from '@/services/utils/figureFormatter'

const { commaFormat } = figureFormatter();

const props = defineProps({
    tableItems: {
        type: Array,
        default: []
    },
    onDeleteItem: {
        type: Function,
        default: () => {}
    }
});

const emit = defineEmits(['onDeleteItem']);
</script>

<style scoped>
.custom-table-padding {
    width: 110%
}

.btn-dlt{
    color: #ea5455;
}
</style>